export enum PlaylistFocusKeys {
  Item = "PLAYLIST:ITEM",
  Entry = "PLAYLIST:ENTRY",
  Icon = "PLAYLIST:ICON",
}
